<template>
	<div>
		<el-aside :width="asidewidth" class="zuo">
			<Zuo @click="Zhankai" />
		</el-aside>
		<el-container class="you" :style="'margin-left:'+asidewidth">
			<el-header class="tou">
				<div ></div>
				<div class="you_img">
					<el-dropdown class="xiala" @command="Caozuo">
						<span class="el-dropdown-link">
							{{yonghu.zhanghao}}<i class="el-icon-arrow-down el-icon--right"></i>
						</span>
						<el-dropdown-menu slot="dropdown">
							<el-dropdown-item v-for="(l,i) in chengshilie" :command="l">{{l.shi}}</el-dropdown-item>
							<el-dropdown-item command="tuichu">退出</el-dropdown-item>
						</el-dropdown-menu>
					</el-dropdown>
					<el-avatar src="http://7niu.zhiwi.cn/vrRSSOOrTD7HsrfHSm9f7cEfMtbREH.jpg" class="touxiang"></el-avatar>
				</div>
			</el-header>
			<el-main class="neirong">
				<router-view></router-view>
			</el-main>
			<!-- <el-footer>底部</el-footer> -->
		</el-container>
	</div>
</template>

<script>
	import Zuo from '../zujian/Zuo.vue'
	export default {
		name: 'app',
		data() {
			return {
				isCollapse: false,
				asidewidth: '200px',
				yonghu: {},
				chengshilie:[],			
			}
		},
		components: {
			Zuo
		},
		created() {
			// console.log(this.$route)
			this.yonghu =this.$shanghu;
			this.ShanghuChengshi()
			this.$shanghu.chengshi=this.$qu('_chengshi')
			
			
		},
		methods: {
			Zhankai(e) {
				this.asidewidth = e;
			},
			Caozuo(e) {
				var that = this;
				if (e == 'tuichu') {
					that.$post('k=denglu&c=Qinghuancun', {
						jianzhi: this.yonghu.kouling
					}, function(s) {
						if (s.shi == 1) {
							localStorage.removeItem('yonghu');
							that.$xiaoxi('退出成功');
							setTimeout(function() {
								that.$dakai('denglu');
							}, 1500)
						} else {
							that.$xiaoxi(s.shu);
						}
					});
				}else{
					this.$cun("_chengshi",e.shi);
					this.$router.go(0)
				}
			},
			ShanghuChengshi(){
				var that=this
				if(this.$shanghu.shanghu){
					this.$post('m=limitao&k=shanghu',function(s) {
						that.$cun('shids',s.hyid)
						if(s.shu.length>0){							
							that.chengshilie=s.shu;
							that.$shanghu.chengshilie=s.shu							
							if(!that.$shanghu.chengshi.length){								
								that.$shanghu.chengshi=s.shu[0].shi;
							}
						}
					});
					
				}
				
			}
		}
	}
</script>
<style>
	body {
		background: #f2f4f8;
	}
	
	/* #app {
	  display: flex;	 
	} */
	.zuo {
		background-color: #041526;
		height: 100vh;
		width: 100%;
		position: fixed;
		top: 0px;
		left: 0;
		width: auto;
		z-index: 99999;
		overflow: initial
	}

	.you {
		margin-left: 200px;
		position: relative;
	}

	.you .tou {
		position: fixed;
		top: 0;
		right: 0px;
		background: #013A8A;
		width: 90%;
		color: #F2F4F8;
		z-index: 999;
		display: flex;
		justify-content: space-between;
	}

	.you .neirong {
		margin-top: 60px;
	}

	.tou_wen {
		font-size: 24px;
		margin-top: 10px;
	}

	.you_img {
		display: flex;
	}

	.el-dropdown-link {
		cursor: pointer;
		color: #FFFFFF;
	}

	.xiala {
		margin-top: 20px;
		margin-right: 10px;
	}

	.touxiang {
		margin-top: 10px;
	}

	.el-icon-s-platform {
		margin-right: 10px;
	}

	/* .you_img:hover{background:#f2f4f8 ;} */
</style>
